import ViewerContainer from 'app/containers/ViewerContainer/ViewerContainer';
import useAmplitude from 'core/hooks/useAmplitude';
import PdfContent from 'core/modules/components/contentsDetail/PdfContent/PdfContent';
import TeacherNotesView from 'core/modules/compositions/TeacherNotesView';
import { isDocumentContent } from 'core/utils/lessonItems';
import { CONTENT_TYPES } from 'core/variables/constant';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import MaterialPreviewViewer from './MaterialPreviewViewer';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';

const MaterialPreviewBodyTeacher = ({ course, material, goToDetailedView, isTwoColums }) => {
  const { sendAmplitudeEvent, AMPLITUDE_EVENT } = useAmplitude();
  // Misma bifurcación que la preview del alumno: `PdfContent` es react-pdf y con una imagen, un vídeo o un audio
  // pinta su error por defecto; esos tipos van al visor. Sin consumo: un profesor previsualizando no consume, y
  // el diálogo de sesiones (que sí consumía antes de TAN-10512) conserva su comportamiento por separado.
  const isDocument = isDocumentContent(material?.content_type_guid);

  useEffect(() => {
    if (
      (material?.content_type_guid === CONTENT_TYPES.LINK && material?.is_embed === 1) ||
      material?.content_type_guid === CONTENT_TYPES.TEST ||
      material?.content_type_guid === CONTENT_TYPES.QUESTION ||
      material?.content_type_guid === CONTENT_TYPES.VIDEOLESSON
    ) {
      const extraParams = { content_type: material.type, content_guid: material.content_guid, from: 'lesson' };
      sendAmplitudeEvent(AMPLITUDE_EVENT.OPEN_CONTENT, extraParams, course);
    }
  }, [material]);

  return (
    <div
      className={`${!material?.content_is_teacher_only ? 'dialog-material-preview__container-viewer' : 'dialog-material-preview__container-viewer-teacher'} ${!isTwoColums ? 'dialog-material-preview__container-viewer-one-columns' : ''}`}
    >
      {material?.teacher_notes && (
        <div className="mb-4">
          <TeacherNotesView text={material.teacher_notes} />
        </div>
      )}

      {material?.description && (
        <div className="dialog-material-preview__description mb-4">
          <TextHtml text={material.description} />
        </div>
      )}

      {material?.useTangerineViewerInPreview && isDocument && (
        <PdfContent contentGuid={material?.content_guid} onClickFullScreen={goToDetailedView} contentType={material?.content_type_guid} />
      )}
      {material?.useTangerineViewerInPreview && !isDocument && (
        <ViewerContainer
          config={{ pdfConfig: [], disabledFetchData: true }}
          contentGuid={material?.content_guid}
          eventParams={{ course, from: 'lesson' }}
          shouldConsumption={false}
          showEmbed
        />
      )}
      {!material?.useTangerineViewerInPreview && <MaterialPreviewViewer material={material} />}
    </div>
  );
};

MaterialPreviewBodyTeacher.propTypes = {
  course: PropTypes.object.isRequired,
  goToDetailedView: PropTypes.func.isRequired,
  material: PropTypes.object.isRequired,
  isTwoColums: PropTypes.bool.isRequired,
};

export default MaterialPreviewBodyTeacher;
